module.exports = __webpack_public_path__ + "img/townstar_inventory.e5271ef.png";